module.exports = __webpack_public_path__ + "img/day-5.7908d644.png";